var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _ellipse5, _path2, _ellipse6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUfoScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf",
    "data-name": "Unbenannter Verlauf",
    x1: 5.52426,
    y1: 23.55693,
    x2: 43.12845,
    y2: 23.55693,
    gradientTransform: "translate(0 59.88983) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97486,
    stopColor: "#f59c00"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 9.22901,
    rx: 10.07606,
    ry: 6.54582,
    fill: "#243d91"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.01783,
    cy: 11.64083,
    rx: 16.86124,
    ry: 4.50262,
    fill: "#371818"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 13.69534,
    rx: 19.36812,
    ry: 4.50262,
    fill: "#f59c00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 15.349,
    rx: 23.34449,
    ry: 4.50262,
    fill: "#82368c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0178,18.55841c-.89165,0-1.95459.08654-1.95459.4988,0,.41207,1.06294.49861,1.95459.49861s1.95459-.08654,1.95459-.49861c0-.41226-1.06294-.4988-1.95459-.4988Z",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 15.349,
    rx: 16.68676,
    ry: 2.84896,
    fill: "#243d91",
    isolation: "isolate",
    opacity: 0.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4893,15.349l11.63915,39.07145s-2.44197-1.2662-7.959-.45222c-5.51703.81399-10.40096,4.16039-14.10913,3.16551-3.70817-.99487-3.07507-1.2662-7.59723-1.44709s-6.34677.54266-7.83121.27133S18.51071,15.349,18.51071,15.349h12.97859Z",
    fill: "url(#Unbenannter_Verlauf)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 15.349,
    rx: 6.4893,
    ry: 1.10793,
    fill: "#765a88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.36599,14.52933c.01082.03174.01921.06367.01921.09613,0,.61189-1.96333,1.10793-4.3852,1.10793s-4.3852-.49604-4.3852-1.10793c0-.03246.00839-.06439.01921-.09613-1.30445.20266-2.12331.49483-2.12331.81967,0,.61189,2.90535,1.10793,6.4893,1.10793s6.4893-.49604,6.4893-1.10793c0-.32484-.81886-.61701-2.12331-.81967Z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15.73338c2.42187,0,4.3852-.49604,4.3852-1.10793,0-.03246-.00839-.06439-.01921-.09613-1.15274-.17908-2.68466-.28826-4.36599-.28826s-3.21325.10918-4.36599.28826c-.01082.03174-.01921.06367-.01921.09613,0,.61189,1.96333,1.10793,4.3852,1.10793Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.26755,7.4111l-.32117-.2174c.05028-.07423,1.24871-1.82724,2.70289-2.44241l.15112.35715c-1.34747.5701-2.52119,2.28542-2.53283,2.30265h0Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.32049,4.79911l-.228-.31369c.03399-.02471.84999-.61091,2.35435-1.01541l.10075.37458c-1.42909.38423-2.21923.94884-2.2271.95452Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75167,7.16322c-.94723-1.44651-2.33163-2.18155-2.34554-2.18875l.17971-.34371c.06031.03153,1.48836.78986,2.49022,2.31998l-.32439.21247h0Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28103,14.60965c-.94136,0-1.95459.23141-1.95459.7393s1.01323.7393,1.95459.7393,1.95459-.23141,1.95459-.7393-1.01323-.7393-1.95459-.7393Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.03977,14.60965c-.94136,0-1.95459.23141-1.95459.7393s1.01323.7393,1.95459.7393,1.95459-.23141,1.95459-.7393-1.01323-.7393-1.95459-.7393Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0178,11.14208c-.89165,0-1.95459.08654-1.95459.4988,0,.41207,1.06294.49861,1.95459.49861s1.95459-.08654,1.95459-.49861c0-.41226-1.06294-.4988-1.95459-.4988Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.09915,
    y: 14.50965,
    width: 0.38782,
    height: 23.66062,
    transform: "translate(-5.05761 7.58689) rotate(-12.79904)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.35614,
    y: 14.85661,
    width: 0.38776,
    height: 25.91357,
    transform: "translate(-3.66163 4.18246) rotate(-8.14251)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63735,
    y: 29.0012,
    width: 28.42724,
    height: 0.3878,
    transform: "translate(-6.97962 51.21001) rotate(-88.37701)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -3.41367,
    y: 33.39639,
    width: 39.49575,
    height: 0.3879,
    transform: "translate(-20.35994 40.5658) rotate(-74.83075)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfoScore);
export default __webpack_public_path__ + "static/media/Ufo_Score.5c37c4a2af4690959b1e194102a5db40.svg";
export { ForwardRef as ReactComponent };